/** One symbol per group, shared by the rail and the landing pages. */
export const NAV_GROUP_ICONS: Readonly<Record<string, string>> = {
  analytics: 'bar_chart',
  surveys: 'assignment',
  features: 'grid_view',
  settings: 'settings',
  admin: 'admin_panel_settings',
};

/** CoPilot is drawn with the Foodback brand mark, not a Material symbol. */
export const BRAND_MARK_GROUP_KEY = 'copilot';

export const NAV_GROUP_ICON_FALLBACK = 'circle';

export function navGroupIcon(key: string, declared?: string): string {
  return NAV_GROUP_ICONS[key] ?? declared ?? NAV_GROUP_ICON_FALLBACK;
}
